import AuthGuest from "../AuthGuest"
import { API_PUBLIC } from "@/app/contants/url"

const PagesService = {
  getPage: (slug: string): AwaitStatusResponse<any> => AuthGuest().get(`${API_PUBLIC}pages/${slug}`)
}
export default PagesService
